export enum ExtendSubscriptionExtensionsFormFields {
  MembershipPlanChanges = 'membershipPlanChanges',
}
